module.exports = __webpack_public_path__ + "img/矩形 2580(1).3fa45489.png";